/*=========================================================================================
  File Name: moduleTypeConfigActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Api from "@/helpers/api.js";

export default {
	// Consulta los tipos de configuración
	getListConfig({commit}) {
		//alert(12)
		return new Promise((resolve, reject) => {
			Api.get("/type/config")
				.then((res) => {
					commit("SET_CONFIG_LIST", res.data);
					resolve(res);
				})
				.catch((err) => {
					console.error(err);
				});
		});
	},
	// Crea un tipo de configuración
	addTypeConfig({commit}, object) {
		return new Promise((resolve, reject) => {
			Api.post("/type/config", object)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	// Elimina tipo de configuración
	removeTypeConfig({commit}, itemId) {
		return new Promise((resolve, reject) => {
			Api.delete(`/type/config/${itemId}`)
				.then((response) => {
					commit("REMOVE_TYPECONFIG", itemId);
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	// Actualiza tipo de configuración
	updateTypeConfig({commit}, item) {
		const {id, ...rest} = item;
		return new Promise((resolve, reject) => {
			Api.put(`/type/config/${id}`, rest)
				.then((response) => {
					resolve(response);
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
};
